<template>
    <div class="floating-uploader-item d-flex flex-column align-items-stretch">
        <div class="d-flex align-items-center">
            <div class="item-avatar img-bg" :style="avatarBackgroundImageStyle">
              <div class="w-100 h-100 d-flex justify-content-center align-items-center bg-gray-200">
                <i v-if="submission.asset_type === 'Video'" class="fas fa-video"></i>
              </div>
            </div>
            <div class="item-name word-break-all mx-2">{{ file.name }}</div>
            <div class="item-progress mr-2">
                <b-progress :value="fileProgress" :max="100" :variant="file.error ? 'danger' : 'success'"/>
            </div>
            <i v-if="fileProgress === 100 && fileStatusSuccess"
               class="ic-done"/>
            <i v-else-if="fileStatusError && file.canRetry"
               class="fas fa-sync-alt"
               v-b-tooltip.hover.left
               title="Retry"
               @click="$emit('retry')"/>
            <i v-else
               @click.prevent.stop="removeFile"
               class="ic-cancel mr-1"/>
        </div>

        <div v-if="fileErrorMessages" class="font-size-sm">
            <div class="mt-2 text-danger" v-for="message in fileErrorMessages">
                {{message}}
            </div>
            <b-button variant="link" @click="removeFile" class="p-0 font-size-sm">Remove File</b-button>
        </div>
    </div>
</template>

<script>
  import Dropzone from 'dropzone'
  import GeneralMixins from "../../../mixins/GeneralMixins";

  export default {
    props: ['file', 'submission'],

    data: function () {
      return {}
    },

    mixins: [GeneralMixins],

    computed: {
      fileStatusError: function () {
        return this.file.status === Dropzone.ERROR;
      },

      fileStatusSuccess: function () {
        return this.file.status === Dropzone.SUCCESS;
      },

      fileError: function () {
        return this.file.error
      },

      fileProgress: function () {
        return this.file.progress
      },

      fileErrorMessages: function () {
        return this.getErrorMessages(this.file.error);
      },

      isRemoving: function () {
        return this.file.removing
      },

      avatarBackgroundImageStyle: function () {
        if (this.submission.asset_type === "Photo" && this.file.asset_url) {
          return `background-image: url(${this.file.asset_url})`
        }
        //TODO: Set a placeholder image if this is missing
        return ""
      }
    },

    methods: {
      removeFile: function (ev) {
        if (this.isRemoving) return;
        this.file.removing = true
        this.$emit('remove', this.file)
      }
    }
  }
</script>